import { render, staticRenderFns } from "./LicitacaoRecursoContrarrazaoTabela.vue?vue&type=template&id=143afe44&scoped=true"
import script from "./LicitacaoRecursoContrarrazaoTabela.vue?vue&type=script&lang=js"
export * from "./LicitacaoRecursoContrarrazaoTabela.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoRecursoContrarrazaoTabela.vue?vue&type=style&index=0&id=143afe44&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143afe44",
  null
  
)

export default component.exports